import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../.././shared/shared.service';
import { Paginator } from 'primeng/primeng';
import { BaseComponent } from '../.././shared/base.component';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { CustomerType, FilterOptions } from '../.././customer/customer.models';
import { LoaderService } from '../.././shared/loader.service';
import { DatePipe } from '@angular/common';
import { CustomerDetailsListEntity, Customerdetails, filteroptions } from 'app/layout/work-order/work-order-models';
@Component({
  // moduleId: module.id,
  selector: 'work-customer-search',
  templateUrl: 'work-customer-search.component.html'
})
export class CustomersSearchComponent extends BaseComponent implements OnInit {
  searchfield = new FormControl();
  griddetails: CustomerDetailsListEntity;
  details: Customerdetails;
  rows: number;
  page: number;
  order: string;
  sortby: string;
  rowsperOptions: any;
  getRows: number;
  filteroptions: filteroptions[];
  filteroptionstype: FilterOptions[];
  filteroptionId: number = 1;
  stacked: boolean;
  selectedId: Customerdetails;
  @Output() done = new EventEmitter();
  @Output() CustID = new EventEmitter();
  CustomerCount: number;
  @Input() isAddress?: boolean = true;
  @Input() isAddressType?: number;
  isProjectEnabled: boolean = false;
  projectNameEnabled: boolean = false;
  frmCustomerLookup: FormGroup;
  isSelectedProject: boolean = false;
  isSelectedEquipment: boolean = false;
  isSelectedCustomer: boolean = false;
  customerType: CustomerType[] = [];
  customerTypeTag: number = 1;
  isAdvanceSearch: boolean = false;
  @ViewChild('paginator') paginator: Paginator;
  hdrCustomerName: string;
  hdrCustomerId: string;
  defaultlookupselect: string;
  constructor(protected translateService: TranslateService, private loaderservice: LoaderService, protected sharedService: SharedService
    , private _datepipe: DatePipe, private formBuilder: FormBuilder) {
    super(sharedService, translateService)
    this.rowsperOptions = this.sharedService.getRowsPerOptions();
    this.getRows = this.sharedService.getRows();
  }
  ngOnInit() {   debugger
    this.frmCustomerLookup = this.formBuilder.group({
      SearchType: [],
      Search: [],
      CustomerTypeId: ['0'],
      CustomerName: [],
      SearchText: [],
      Searchby: []

    });
    this.frmCustomerLookup.patchValue(
      {
        SearchType: '1',
      });
    this.getfilteroptions();
    if (this.filteroptions.length > 0)
      this.frmCustomerLookup.controls["Searchby"].setValue(this.filteroptions[0].id);
    this.filteroptionstype = this.getSearchByColumnDropdown(0);
    this.isProjectEnabled = (super.globalInfo().ProjectEnabled == 1);
    this.isSelectedProject = false;
    this.isSelectedEquipment = false;
    this.isSelectedCustomer = true;
    this.loaderservice.show();
    this.griddetails = new CustomerDetailsListEntity;
    if (this.details == null) {
      this.details = new Customerdetails;
    }
    if (this.griddetails == null) {
      this.griddetails = new CustomerDetailsListEntity;
    }
    this.details.AddressType = this.isAddressType;
    this.details.CompanyID = super.globalInfo().CompanyId;
    this.details.LoginId = this.globalInfo().LoginId;
    this.details.MaxRoleGroup = this.globalInfo().MaxRoleGroup;
    this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
    this.details.CustomerId = null;
    
    this.rows = this.getRows;
    this.page = 0;
    this.order = "CustomerName";
    this.sortby = "Asc";
    this.getCompanySetting(); 
    this.getCustomerTypes();
    this.paginator.first = 0;
  } //onInit ends
  //Elixir purpose we changed the code in Product start 09/04/2019
  getSystemsetting() {
    this.sharedService.getSystemSettingByIds(this.globalInfo().CompanyId, 126).subscribe(val => {
      this.defaultlookupselect = val[0].SettingValue;
      this.frmCustomerLookup.controls["SearchType"].setValue(this.defaultlookupselect);
      this.onradioChange(parseInt(this.defaultlookupselect));

    });
  }
  //Elixir purpose we changed the code in Product start 09/04/2019
  refreshGrid() {

    this.loaderservice.show();
    this.details.CompanyID = super.globalInfo().CompanyId;
    this.rows = this.getRows;
    this.details.Type = this.frmCustomerLookup.controls["SearchType"].value;
    if (this.details.Type == 1) {
      this.page = 0;
      this.details.startRecord = this.page;
      this.details.EndRecord = this.rows;
    }
    else if (this.details.Type == 2) {
      this.page = 0;
      this.details.startRecord = this.page;
      this.details.EndRecord = this.rows;
    }
    else if (this.details.Type == 3) {
      this.page = 0;
      this.details.startRecord = this.page;
      this.details.EndRecord = this.rows;
    }

    this.order = "CustomerName";
    this.sortby = "Asc";
    this.details.SortBy = this.sortby;
    this.details.OrderBy = this.order;
    if (this.frmCustomerLookup.controls["Search"].value) {
      this.details.Search = this.frmCustomerLookup.controls["Search"].value
    }
    else {
      this.details.Search = this.frmCustomerLookup.controls["Search"].value
      this.details.Type = this.frmCustomerLookup.controls["SearchType"].value;
      this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
      this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value;
      var data = this.frmCustomerLookup.controls["Searchby"].value;
      this.filterquery(data.toString());
    }
    this.sharedService.searchCustomerslookup(this.details).subscribe(resp => {
      if (resp != null) {
        this.griddetails = new CustomerDetailsListEntity;
        this.griddetails = resp;
        this.CustomerCount = resp.TotalRecord;
        if (this.details.Type == 2) {
          resp.CustomerList.forEach(x => {

            x.ProjectStartDate = x.ProjectStartDate ? this._datepipe.transform(new Date(x.ProjectStartDate), "yyyy/MMM/dd") : null;
            x.ProjectEndDate = x.ProjectEndDate ? this._datepipe.transform(new Date(x.ProjectEndDate), "yyyy/MMM/dd") : null;
            x.tProjectStartDate = this._datepipe.transform(x.ProjectStartDate, 'shortDate');
            x.tProjectEndDate = this._datepipe.transform(x.ProjectEndDate, 'shortDate');

          });

        }
        else if (this.details.Type == 3) {
          resp.CustomerList.forEach(x => {

            x.ContractStartDate = x.ContractStartDate ? this._datepipe.transform(new Date(x.ContractStartDate), "yyyy/MMM/dd") : null;
            x.ContractEndDate = x.ContractEndDate ? this._datepipe.transform(new Date(x.ContractEndDate), "yyyy/MMM/dd") : null;
            x.tContractStartDate = this._datepipe.transform(x.ContractStartDate, 'shortDate');
            x.tContractEndDate = this._datepipe.transform(x.ContractEndDate, 'shortDate');

          });
        }
        this.griddetails.CustomerList = resp.CustomerList;
        if (this.customerTypeTag == 1) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERID');
        }
        if (this.customerTypeTag == 2) {
          this.hdrCustomerName = this.translate.instant('NETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CLLICODE');
        }
        if (this.customerTypeTag == 3) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERIDCLLICODE');
        }
        this.loaderservice.hide();
      }
    });
    this.paginator.first = 0;
    this.paginator.rows = this.getRows;
  }
  onchangeClear() {

    this.frmCustomerLookup.patchValue(
      {
        Search: '',
        CustomerTypeId: 0,
        CustomerName: '',
        SearchText: ''
      });

  }
  onradioChange(value: number) {
    this.onchangeClear();
    this.getfilteroptions();
    this.details.Type = value;
    if (value == 1) {
      this.loaderservice.show();
      this.isSelectedProject = false;
      this.isSelectedEquipment = false;
      this.isSelectedCustomer = true;
    }
    else if (value == 2) {
      this.loaderservice.show();
      this.isSelectedProject = true;
      this.isSelectedEquipment = false;
      this.isSelectedCustomer = false;
      var data = this.filteroptionId;
    }
    else if (value == 3) {
      this.loaderservice.show();
      this.isSelectedProject = false;
      this.isSelectedEquipment = true;
      this.isSelectedCustomer = false;
    }
    this.filteroptionId = 2;

    this.frmCustomerLookup.controls["Searchby"].setValue(this.filteroptions[0].id);
    this.getCustomerlist();
  }
  getCustomerlist() {
    this.loaderservice.show();
    this.rows = this.getRows;
    this.details.SortBy = this.sortby;
    this.details.OrderBy = this.order;
    this.details.Type = this.frmCustomerLookup.controls["SearchType"].value;
    if (this.details.Type == 1) {
      this.page = 0;
      this.details.startRecord = this.page;
      this.details.EndRecord = this.rows;

    }
    else if (this.details.Type == 2) {
      this.page = 0;
      this.details.startRecord = this.page;
      this.details.EndRecord = this.rows;
    }
    else if (this.details.Type == 3) {
      this.page = 0;
      this.details.startRecord = this.page;
      this.details.EndRecord = this.rows;
    }
    if (this.frmCustomerLookup.controls["Search"].value) {
      this.details.Search = this.frmCustomerLookup.controls["Search"].value
    }
    else {

      this.details.Type = this.frmCustomerLookup.controls["SearchType"].value;


      this.details.Search = this.frmCustomerLookup.controls["Search"].value
      this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
      this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value;

    }

    var data = this.frmCustomerLookup.controls["Searchby"].value;
    this.filterquery(data.toString());

    this.sharedService.searchCustomerslookup(this.details).subscribe(resp => {
      if (resp != null) {

        this.griddetails = new CustomerDetailsListEntity;
        if (this.details.Type == 2) {
          resp.CustomerList.forEach(x => {

            x.ProjectStartDate = x.ProjectStartDate ? this._datepipe.transform(new Date(x.ProjectStartDate), "yyyy/MMM/dd") : null;
            x.ProjectEndDate = x.ProjectEndDate ? this._datepipe.transform(new Date(x.ProjectEndDate), "yyyy/MMM/dd") : null;
            x.tProjectStartDate = this._datepipe.transform(x.ProjectStartDate, 'shortDate');
            x.tProjectEndDate = this._datepipe.transform(x.ProjectEndDate, 'shortDate');

          });

        }
        else if (this.details.Type == 3) {
          resp.CustomerList.forEach(x => {

            x.ContractStartDate = x.ContractStartDate ? this._datepipe.transform(new Date(x.ContractStartDate), "yyyy/MMM/dd") : null;
            x.ContractEndDate = x.ContractEndDate ? this._datepipe.transform(new Date(x.ContractEndDate), "yyyy/MMM/dd") : null;
            x.tContractStartDate = this._datepipe.transform(x.ContractStartDate, 'shortDate');
            x.tContractEndDate = this._datepipe.transform(x.ContractEndDate, 'shortDate');

          });
        }
        this.griddetails = resp;
        this.CustomerCount = resp.TotalRecord;
        this.griddetails.CustomerList = resp.CustomerList;

        if (this.customerTypeTag == 1) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERID');
        }
        if (this.customerTypeTag == 2) {
          this.hdrCustomerName = this.translate.instant('NETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CLLICODE');
        }
        if (this.customerTypeTag == 3) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERIDCLLICODE');
        }
        this.loaderservice.hide();
      }
    });
    this.paginator.first = 0;
    this.paginator.rows = this.getRows;

  }

  paginate(event) {

    var status = -1;
    this.details.SortBy = this.sortby;
    this.details.OrderBy = this.order;
    this.details.startRecord = event.page;
    this.page = event.page;
    this.details.EndRecord = event.rows;
    this.rows = event.rows;


    this.details.Type = this.frmCustomerLookup.controls["SearchType"].value;


    if (this.frmCustomerLookup.controls["Search"].value) {
      this.details.Search = this.frmCustomerLookup.controls["Search"].value
    }
    else {
      this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value;
      this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
      this.details.Search = this.frmCustomerLookup.controls["Search"].value

    }
    var data = this.frmCustomerLookup.controls["Searchby"].value;
    this.filterquery(data.toString());
    this.sharedService.searchCustomerslookup(this.details).subscribe(resp => {
      if (resp != null) {
        this.griddetails = new CustomerDetailsListEntity;
        if (this.details.Type == 2) {
          resp.CustomerList.forEach(x => {

            x.ProjectStartDate = x.ProjectStartDate ? this._datepipe.transform(new Date(x.ProjectStartDate), "yyyy/MMM/dd") : null;
            x.ProjectEndDate = x.ProjectEndDate ? this._datepipe.transform(new Date(x.ProjectEndDate), "yyyy/MMM/dd") : null;
            x.tProjectStartDate = this._datepipe.transform(x.ProjectStartDate, 'shortDate');
            x.tProjectEndDate = this._datepipe.transform(x.ProjectEndDate, 'shortDate');

          });

        }
        else if (this.details.Type == 3) {
          resp.CustomerList.forEach(x => {

            x.ContractStartDate = x.ContractStartDate ? this._datepipe.transform(new Date(x.ContractStartDate), "yyyy/MMM/dd") : null;
            x.ContractEndDate = x.ContractEndDate ? this._datepipe.transform(new Date(x.ContractEndDate), "yyyy/MMM/dd") : null;
            x.tContractStartDate = this._datepipe.transform(x.ContractStartDate, 'shortDate');
            x.tContractEndDate = this._datepipe.transform(x.ContractEndDate, 'shortDate');

          });
        }
        this.griddetails = resp;
        if (this.customerTypeTag == 1) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERID');
        }
        if (this.customerTypeTag == 2) {
          this.hdrCustomerName = this.translate.instant('NETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CLLICODE');
        }
        if (this.customerTypeTag == 3) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERIDCLLICODE');
        }
      }
    });
  }
  sort(event) {

    var status = -1;
    if (event.order == 1)
      this.sortby = "Asc";
    else
      this.sortby = "Desc";
    this.details.SortBy = this.sortby;
    this.details.OrderBy = event.field;
    this.order = event.field;

    this.details.Type = this.frmCustomerLookup.controls["SearchType"].value;


    this.details.startRecord = this.page;
    this.details.EndRecord = this.rows;
    if (this.frmCustomerLookup.controls["Search"].value) {
      this.details.Search = this.frmCustomerLookup.controls["Search"].value
    }
    else {
      this.details.Search = this.frmCustomerLookup.controls["Search"].value
      this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value;
      this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;


    }
    var data = this.frmCustomerLookup.controls["Searchby"].value;
    this.filterquery(data.toString());
    this.sharedService.searchCustomerslookup(this.details).subscribe(resp => {
      if (resp != null) {
        this.griddetails = new CustomerDetailsListEntity;
        if (this.details.Type == 2) {
          resp.CustomerList.forEach(x => {

            x.ProjectStartDate = x.ProjectStartDate ? this._datepipe.transform(new Date(x.ProjectStartDate), "yyyy/MMM/dd") : null;
            x.ProjectEndDate = x.ProjectEndDate ? this._datepipe.transform(new Date(x.ProjectEndDate), "yyyy/MMM/dd") : null;
            x.tProjectStartDate = this._datepipe.transform(x.ProjectStartDate, 'shortDate');
            x.tProjectEndDate = this._datepipe.transform(x.ProjectEndDate, 'shortDate');

          });

        }
        else if (this.details.Type == 3) {
          resp.CustomerList.forEach(x => {

            x.ContractStartDate = x.ContractStartDate ? this._datepipe.transform(new Date(x.ContractStartDate), "yyyy/MMM/dd") : null;
            x.ContractEndDate = x.ContractEndDate ? this._datepipe.transform(new Date(x.ContractEndDate), "yyyy/MMM/dd") : null;
            x.tContractStartDate = this._datepipe.transform(x.ContractStartDate, 'shortDate');
            x.tContractEndDate = this._datepipe.transform(x.ContractEndDate, 'shortDate');

          });
        }
        this.griddetails = resp;
        if (this.customerTypeTag == 1) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERID');
        }
        if (this.customerTypeTag == 2) {
          this.hdrCustomerName = this.translate.instant('NETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CLLICODE');
        }
        if (this.customerTypeTag == 3) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERIDCLLICODE');
        }
      }
    });
  }
  getCustomerTypes() {
    this.sharedService.getCustomerTypes(super.globalInfo().CompanyId).subscribe(res => {
      var isNetwork = 0;
      var isBusiness = 0;

      this.customerType = res;
      if (this.customerType.length > 0) {
        for (var i = 0; i <= this.customerType.length - 1; i++) {
          if (this.customerType[i].IsNetwork == 1) {
            isNetwork = 1;
          }
          if (this.customerType[i].IsNetwork == 0) {
            isBusiness = 1;
          }
        }
      }


      //  1-business 2-Network, 3 both
      if (isNetwork == 0 && isBusiness == 1) {
        this.filteroptionstype = this.getSearchByColumnDropdown(1);
        this.customerTypeTag = 1;
      }
      else if (isNetwork == 1 && isBusiness == 0) {
        this.filteroptionstype = this.getSearchByColumnDropdown(2);
        this.customerTypeTag = 2;
      }
      else if (isNetwork == 1 && isBusiness == 1) {
        this.filteroptionstype = this.getSearchByColumnDropdown(3);
        this.customerTypeTag = 3;
      }
      else {
        this.filteroptionstype = this.getSearchByColumnDropdown(1);
        this.customerTypeTag = 1;
      }


      if (this.customerTypeTag == 1) {
        this.hdrCustomerName = this.translate.instant('CUSTOMERNAME');
        this.hdrCustomerId = this.translate.instant('CUSTOMERID');
      }
      if (this.customerTypeTag == 2) {
        this.hdrCustomerName = this.translate.instant('NETWORKNAME');
        this.hdrCustomerId = this.translate.instant('CLLICODE');
      }
      if (this.customerTypeTag == 3) {
        this.hdrCustomerName = this.translate.instant('CUSTOMERNETWORKNAME');
        this.hdrCustomerId = this.translate.instant('CUSTOMERIDCLLICODE');
      }

    });
  }
  getSearchByColumnDropdown(id) {

    // this.getCustomerTypes();
    let rr: string[] = ['ADDRESS', 'POSTALCODE', 'CONTACTNAME', 'CONTACTPHONE', 'CUSTOMERNAME',
      'CUSTOMERID', 'CUSTOMERPHONE', 'NETWORKNAME', 'CLLICODE', 'CUSTOMERNETWORKNAME', 'CUSTOMERIDCLLICODE', 'PROJECTNAME', 'ADDRESSNAME'];
    var t;
    this.translate.get(rr).subscribe(s => {
      t = s

      if (id == 1) {
        this.filteroptionstype = [
          new FilterOptions(1, t.CUSTOMERNAME),
          new FilterOptions(2, t.CUSTOMERID),
          new FilterOptions(3, t.CUSTOMERPHONE),
          new FilterOptions(4, t.ADDRESS),
          new FilterOptions(5, t.POSTALCODE),
          new FilterOptions(6, t.CONTACTNAME),
          new FilterOptions(7, t.CONTACTPHONE),
          new FilterOptions(8, t.ADDRESSNAME)
        ];

      }
      else if (id == 2) {
        this.filteroptionstype = [
          new FilterOptions(1, t.NETWORKNAME),
          new FilterOptions(2, t.CLLICODE),
          // new FilterOptions(2, t.CUSTOMERID),
          new FilterOptions(4, t.ADDRESS),
          new FilterOptions(5, t.POSTALCODE),
          new FilterOptions(6, t.CONTACTNAME),
          new FilterOptions(7, t.CONTACTPHONE),
          new FilterOptions(8, t.ADDRESSNAME),
        ];

      }
      else if (id == 3) {
        this.filteroptionstype = [
          new FilterOptions(1, t.CUSTOMERNETWORKNAME),
          new FilterOptions(2, t.CUSTOMERIDCLLICODE),
          new FilterOptions(4, t.ADDRESS),
          new FilterOptions(5, t.POSTALCODE),
          new FilterOptions(6, t.CONTACTNAME),
          new FilterOptions(7, t.CONTACTPHONE),
          new FilterOptions(8, t.ADDRESSNAME),
        ];

      }



    });


    return this.filteroptionstype;

  }
  onfilterChange(Id) {

    this.filteroptionId = Id;
  }

  getfilteroptions() {
    debugger;
    let rr: string[] = ['CUSTOMERNAMENETWORKNAME', 'CUSTOMERIDCLLICODE', 'PROJECTNAME',
      'PROJECTTYPE', 'WBSNO', 'ADDRESSNAME', 'BRANDNAME', 'MODEL', 'SERIALNO', 'TAGNO',
      'DESCRIPTION', 'PRIORITYNAME', 'CUSTOMERNAME', 'SITEID', 'CUSTYPE', 'ADDRESS', 'STATUS',
      'CUS_PHONE', 'CUS_MOBILE'];


    if (this.frmCustomerLookup.controls["SearchType"].value == 2) {
      let t;
      this.translateService.get(rr).subscribe(s => {
        t = s

        this.filteroptions = [
          new filteroptions(1, t.CUSTOMERNAMENETWORKNAME),
          new filteroptions(2, t.CUSTOMERIDCLLICODE),
          new filteroptions(8, t.PROJECTNAME),
          new filteroptions(14, t.PROJECTTYPE),
          new filteroptions(16, t.WBSNO),
          new filteroptions(33, t.ADDRESSNAME)
        ];
      });

    }
    else if (this.frmCustomerLookup.controls["SearchType"].value == 1) {
      if (this.isAddress == false) {
        let t;
        this.translateService.get(rr).subscribe(s => {
          t = s
          this.filteroptions = [
            new filteroptions(1, t.CUSTOMERNAME),
            new filteroptions(2, t.SITEID),
            new filteroptions(3, t.CUSTYPE),
            new filteroptions(4, t.ADDRESS),
            new filteroptions(5, t.PHONE),
            // new filteroptions(6, 'Contact Name'),
            new filteroptions(7, t.STATUS),
            new filteroptions(33, t.ADDRESSNAME)
          ];
        });
      }
      else {
        let t;
        this.translateService.get(rr).subscribe(s => {
          t = s;
          this.filteroptions = [

            //  new filteroptions(1, 'Customer Name'),
            new filteroptions(2, t.SITEID),
            //   new filteroptions(3, 'Type'),
            new filteroptions(4, t.ADDRESS),
            new filteroptions(5, t.CUS_PHONE),
            new filteroptions(15, t.CUS_MOBILE),
            // new filteroptions(6, 'Contact Name'),
            new filteroptions(7, t.STATUS),
            new filteroptions(33, t.ADDRESSNAME)
          ];
        });
      }
    }
    else if (this.frmCustomerLookup.controls["SearchType"].value == 3) {
      let t;
      this.translateService.get(rr).subscribe(s => {
        t = s;
        this.filteroptions = [
          new filteroptions(2, t.CUSTOMERIDCLLICODE),
          new filteroptions(9, t.BRANDNAME),
          new filteroptions(10, t.MODEL),
          new filteroptions(11, t.TAGNO),
          new filteroptions(12, t.SERIALNO),
          new filteroptions(13, t.DESCRIPTION),
          new filteroptions(17, t.PRIORITYNAME),
          new filteroptions(33, t.ADDRESSNAME)
        ];
      });
    }
  }
  toggle() {
    this.stacked = !this.stacked;
  }
  onclickec() {
    {

      this.loaderservice.show();
      var data = this.frmCustomerLookup.controls["Searchby"].value;
      this.details.SortBy = this.sortby;
      this.details.OrderBy = this.order;
      // this.details.startRecord = this.page;
      // this.details.EndRecord = this.rows;

      if (this.details.Type == 1) {
        this.page = 0;
        this.details.startRecord = this.page;
        this.details.EndRecord = this.rows;
      }
      else if (this.details.Type == 2) {
        this.page = 0;
        this.details.startRecord = this.page;
        this.details.EndRecord = this.rows;
      }
      else if (this.details.Type == 3) {
        this.page = 0;
        this.details.startRecord = this.page;
        this.details.EndRecord = this.rows;
      }

      this.details.Type = this.frmCustomerLookup.controls["SearchType"].value;


      this.details.Search = this.frmCustomerLookup.controls["Search"].value;

      this.filterquery(data.toString());
      this.sharedService.searchCustomerslookup(this.details).subscribe(resp => {
        //if (resp != null) {
        this.griddetails = new CustomerDetailsListEntity;
        if (this.details.Type == 2) {
          resp.CustomerList.forEach(x => {

            x.ProjectStartDate = x.ProjectStartDate ? this._datepipe.transform(new Date(x.ProjectStartDate), "yyyy/MMM/dd") : null;
            x.ProjectEndDate = x.ProjectEndDate ? this._datepipe.transform(new Date(x.ProjectEndDate), "yyyy/MMM/dd") : null;
            x.tProjectStartDate = this._datepipe.transform(x.ProjectStartDate, 'shortDate');
            x.tProjectEndDate = this._datepipe.transform(x.ProjectEndDate, 'shortDate');

          });

        }
        else if (this.details.Type == 3) {
          resp.CustomerList.forEach(x => {

            x.ContractStartDate = x.ContractStartDate ? this._datepipe.transform(new Date(x.ContractStartDate), "yyyy/MMM/dd") : null;
            x.ContractEndDate = x.ContractEndDate ? this._datepipe.transform(new Date(x.ContractEndDate), "yyyy/MMM/dd") : null;
            x.tContractStartDate = this._datepipe.transform(x.ContractStartDate, 'shortDate');
            x.tContractEndDate = this._datepipe.transform(x.ContractEndDate, 'shortDate');

          });
        }
        this.griddetails = resp;
        this.CustomerCount = resp.TotalRecord;
        if (this.customerTypeTag == 1) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERID');
        }
        if (this.customerTypeTag == 2) {
          this.hdrCustomerName = this.translate.instant('NETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CLLICODE');
        }
        if (this.customerTypeTag == 3) {
          this.hdrCustomerName = this.translate.instant('CUSTOMERNETWORKNAME');
          this.hdrCustomerId = this.translate.instant('CUSTOMERIDCLLICODE');
        }
        this.loaderservice.hide();
      });
    }
    this.paginator.first = 0;
    this.paginator.rows = this.getRows;
  }
  filterquery(data: string) {
    this.details.ProjectName = null;
    var CustomerTypes;
    if (this.frmCustomerLookup.controls["CustomerTypeId"].value != 0) {
      CustomerTypes = this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)
    }
    this.details.AddressName = "";
    this.details.Searchby = this.frmCustomerLookup.controls["Searchby"].value;
    this.details.SearchText = "";
    switch (data) {
      case "1":

        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value ? this.frmCustomerLookup.controls["CustomerName"].value : this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "2":
        this.details.CustomerId = null;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.AddressLine1 = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        this.details.SearchText = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        break;
      case "3":

        this.details.CustomerType = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerId = null;
        this.details.AddressLine1 = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "4":

        this.details.AddressLine1 = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "5":

        this.details.phone1 = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone2 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "6":

        this.details.ContactName = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.CustomerStatus = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "7":

        this.details.CustomerStatus = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "8":

        this.details.ProjectName = this.frmCustomerLookup.controls["SearchText"].value == null ? "" : this.frmCustomerLookup.controls["SearchText"].value;
        this.details.CustomerStatus = null;
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "9":

        this.details.Brand = this.frmCustomerLookup.controls["SearchText"].value == null ? "" : this.frmCustomerLookup.controls["SearchText"].value;
        this.details.Model = null;
        this.details.TagNo = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.SerialNo = null;
        this.details.Description = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "10":
        this.details.Brand = null;
        this.details.Model = this.frmCustomerLookup.controls["SearchText"].value == null ? "" : this.frmCustomerLookup.controls["SearchText"].value;
        this.details.TagNo = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.SerialNo = null;
        this.details.Description = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;

      case "11":
        this.details.Brand = null;
        this.details.Model = null;
        this.details.TagNo = this.frmCustomerLookup.controls["SearchText"].value == null ? "" : this.frmCustomerLookup.controls["SearchText"].value;;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.SerialNo = null;
        this.details.Description = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "12":
        this.details.Brand = null;
        this.details.Model = null;
        this.details.TagNo = null
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.SerialNo = this.frmCustomerLookup.controls["SearchText"].value == null ? "" : this.frmCustomerLookup.controls["SearchText"].value;
        this.details.Description = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "13":
        this.details.Brand = null;
        this.details.Model = null;
        this.details.TagNo = null
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.SerialNo = null;
        this.details.Description = this.frmCustomerLookup.controls["SearchText"].value == null ? "" : this.frmCustomerLookup.controls["SearchText"].value;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "14":

        this.details.ProjectType = this.frmCustomerLookup.controls["SearchText"].value == null ? "" : this.frmCustomerLookup.controls["SearchText"].value;
        this.details.CustomerStatus = null;
        this.details.AddressLine1 = null;
        this.details.CustomerName = null;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.phone2 = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.PriorityName = null;
        break;
      case "15":

        this.details.phone2 = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "16":
        this.details.WBSno = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;

        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        break;
      case "17":
        this.details.PriorityName = this.isAddress == true ? this.frmCustomerLookup.controls["SearchText"].value : this.frmCustomerLookup.controls["Search"].value;
        this.details.WBSno = null
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;

        this.details.ProjectName = null;
        this.details.ProjectType = null;
        break;
      case "33":
        this.details.phone2 = null;
        this.details.Search = this.isAddress == true ? this.frmCustomerLookup.controls["Search"].value : '';
        this.details.AddressLine1 = null;
        this.details.CustomerName = this.frmCustomerLookup.controls["CustomerName"].value;
        this.details.CustomerType = this.frmCustomerLookup.controls["CustomerTypeId"].value != 0 ? this.customerType.filter(x => x.CustomerTypeId == this.frmCustomerLookup.controls["CustomerTypeId"].value)[0].CustomerType : '';
        this.details.CustomerId = null;
        this.details.phone1 = null;
        this.details.CustomerStatus = null;
        this.details.ContactName = null;
        this.details.WBSno = null;
        this.details.ProjectName = null;
        this.details.ProjectType = null;
        this.details.PriorityName = null;
        this.details.AddressName = this.frmCustomerLookup.controls["SearchText"].value;
        break;
    }
  }
  onRowSelect(value) {
    this.done.emit({ selcustomer: value, type: this.frmCustomerLookup.controls["SearchType"].value });
  }

  closePopup() {
    this.done.emit({ selcustomer: null, type: this.frmCustomerLookup.controls["SearchType"].value });
    this.loaderservice.hide();
  }
  EnablePreferVendorForCustomer: number = 0;
  getCompanySetting() {
    this.sharedService.getCompany(this.globalInfo().CompanyId).subscribe(
      s => {
        this.EnablePreferVendorForCustomer = s.EnablePreferVendorForCustomer;       
        this.details.EnablePreferVendorForCustomer = this.EnablePreferVendorForCustomer;
        this.getSystemsetting();
      }
    );
  }
}